'use strict';

/* jshint -W098 */
angular.module('mean.builders').controller('BuilderCalendarController', ['$scope', 'Users', 'Global', 'Foreman', 'MeanUser', 'ProjectTasks', '$filter', 'Projects', 'ProjectBids', 'Builders', 'taskService', 'ngDialog', '$q', 'foremanCalendarService', 'userService', 'contactService', 'Trades', 'taskListService', 'tradeCodeService', 'aceUtils', 'builderService',
  function($scope, Users, Global, Foreman, MeanUser, ProjectTasks, $filter, Projects, ProjectBids, Builders, taskService, ngDialog, $q, foremanCalendarService, userService, contactService, Trades, taskListService, tradeCodeService, aceUtils, builderService) {
    $scope.global = Global;
    $scope.package = {
      name: 'foreman'
    };

    $scope.user = MeanUser.user;
    $scope.showTasks = false;
    $scope.tasks = [];

    if(!builderService.isBuilder($scope.user.username)) {
        alert('Must be a builder to view this page');
        return;
    }

    $scope.main_username = userService.getTradeCode($scope.user.username) +
        userService.getCompanyCode($scope.user.username) + '0000';

    $scope.init = function() {
        userService.getMainAccountId(MeanUser.user.username).then(function(result) {
            Builders.query({'builder': result}, function(builders) {
                $scope.selectedBuilder = builders[0];
                $scope.changeBuilder();
            });
        });

        $scope.trades = tradeCodeService.getArray();
        $scope.trades.unshift({
            name: 'All'
        });

        taskListService.get().then(function(tasks) {
                $scope.tasks = $filter('orderBy')(tasks, 'task_code');
                var obj = {};
                obj.task_name = 'All';
                $scope.tasks.unshift(obj);
        });
    };

    var eventInfo = function(event) {
        $scope.event_start;
        $scope.event_end;
        if(event.allDay) {
            $scope.event_start = moment(event.start).add(1, 'days');
            $scope.event_end = moment($scope.event_start).clone().add(8, 'hours');
        } else {
            $scope.event_start = moment(event.start);
            $scope.event_end = moment(event.end).clone();
        }
        var newScope = $scope.$new();

        var builder, trade, task_code, proj_id, phase, lot;

        builder = $scope.main_username;

        if (aceUtils.isUndefinedOrNull($scope.selectedTrade)) {
            trade = ''; 
        } else {
            trade = ($scope.selectedTrade.name === 'All') ? '' : $scope.selectedTrade.name;
        }

        if (aceUtils.isUndefinedOrNull($scope.selectedItem)) {
            proj_id = ''; 
        } else {
            proj_id = ($scope.selectedItem.number === 'All') ? '' : $scope.selectedItem._id;
        }

        if (aceUtils.isUndefinedOrNull($scope.selectedPhase)) { 
            phase = ''; 
        } else {
            phase = ($scope.selectedPhase.name === 'All') ? '' : $scope.selectedPhase.name;
        }

        if (aceUtils.isUndefinedOrNull($scope.selectedLot)) { 
            lot = ''; 
        } else {
            if($scope.selectedLot.number === 'All') {
                lot = '';
            } else {
                lot = $scope.selectedLot.number;
                phase = $scope.selectedLot.phase;
            }
        }

        if (aceUtils.isUndefinedOrNull($scope.selectedTask)) { 
            task_code = ''; 
        } else {
            task_code = ($scope.selectedTask.task_name === 'All') ? '' : $scope.selectedTask.task_code;
        }

        //have to grab a wider range of dates
        //so we can get tasks that span multiple days
        var task_start = moment($scope.event_start).clone().subtract(7, 'days');
        var task_end = moment($scope.event_end).clone().add(7, 'days');

        taskService.getByBuilderAndDateRange(builder, trade, 
            proj_id, phase, lot, task_code, task_start, task_end, 
            true).then(function(tasks) {
            //we need to find tasks that have multiple days and
            //divide them in to their own task entry
            var new_tasks = foremanCalendarService.separateTasks(tasks);

            foremanCalendarService.tasksForDialog(new_tasks, $scope.event_start).then(function(result) {
                newScope.day_tasks = result;
                newScope.cal_date = new Date($scope.event_start);
                ngDialog.open({ template: 'foreman/views/foreman_calendar_dialog_template.html', scope: newScope, className: 'ngdialog-theme-default'});
            });
        });
    };

    var getEvents = function(start, end, timezone, callback) {
        $scope.events = [];

        var builder, task_code, trade, proj_id, phase, lot;
        
        builder = $scope.main_username;

        if (aceUtils.isUndefinedOrNull($scope.selectedTrade)) {
            trade = ''; 
        } else {
            trade = ($scope.selectedTrade.name === 'All') ? '' : $scope.selectedTrade.name;
        }

        if (aceUtils.isUndefinedOrNull($scope.selectedItem)) {
            proj_id = ''; 
        } else {
            proj_id = ($scope.selectedItem.number === 'All') ? '' : $scope.selectedItem._id;
        }

        if (aceUtils.isUndefinedOrNull($scope.selectedPhase)) { 
            phase = ''; 
        } else {
            phase = ($scope.selectedPhase.name === 'All') ? '' : $scope.selectedPhase.name;
        }

        if (aceUtils.isUndefinedOrNull($scope.selectedLot)) { 
            lot = ''; 
        } else {
            if($scope.selectedLot.number === 'All') {
                lot = '';
            } else {
                lot = $scope.selectedLot.number;
                phase = $scope.selectedLot.phase;
            }
        }

        if (aceUtils.isUndefinedOrNull($scope.selectedTask)) { 
            task_code = ''; 
        } else {
            task_code = ($scope.selectedTask.task_name === 'All') ? '' : $scope.selectedTask.task_code;
        }

        
        taskService.getByBuilderAndDateRange(builder, trade, 
            proj_id, phase, lot, task_code, start, end, true).then(function(tasks) {
            if(tasks.length > 0)
              $scope.events = foremanCalendarService.getEvents(tasks);
            callback($scope.events);
        });
    };

    // $scope.loading = function(isLoading, view){
    //   alert("is loading" + isLoading);
    // }

    $scope.uiConfig = {
      calendar:{
        editable: false,
        businessHours: true,
        header:{
          left: 'month basicWeek basicDay',
          center: 'title',
          right: 'today prev,next'
        },
        defaultView: 'month',
        dayClick: alertEventOnClick,
        eventClick: eventInfo,
        events: getEvents,
        loading: $scope.loading,
        eventRender: function(event, element) {
            element.find('.fc-title').append('<br/> Hours: ' + 
                $filter('number')(event.hours, 2) + '<br/> Men Needed: ' + 
                $filter('number')(event.hours/8, 2));
        }
      }
    };

    var alertEventOnClick = function(date, jsEvent, view) {
        console.log('dayClick event');
    };

    $scope.events = [];
    $scope.eventSources = [$scope.events];

    $scope.changeBuilder = function() {
        $scope.projects = [];
        $scope.lots = [];
        $scope.showTasks = false;

        Projects.query({'builder.name': $scope.selectedBuilder.name, 'complete': false}, function(projects) {
            $scope.projects = projects;
        });
    };

    $scope.changeProject = function() {
        $scope.lots = [];
        $scope.showTasks = false;

        if (aceUtils.isUndefinedOrNull($scope.selectedItem)) return;

        $scope.lots = $filter('orderBy')($scope.selectedItem.lots, ['number'], false);
        var obj = {};
        obj.number = 'All';
        $scope.lots.unshift(obj);

        $scope.phases = [];

        $scope.phases.push({
            name: 'All'
        });

        for(var i=0; i<$scope.selectedItem.lots.length; i++) {
            var inlist = $filter('filter')($scope.phases, { 
                'name': $scope.selectedItem.lots[i].phase}, true);

            if(inlist.length === 0)
                $scope.phases.push({
                    name: $scope.selectedItem.lots[i].phase
                });
        }
    };

    $scope.changePhase = function() {
        $scope.lots = [];

        if($scope.selectedPhase.name === 'All') {
            $scope.lots = $filter('orderBy')($scope.selectedItem.lots, ['number'], false);
        } else {
            var removed = $filter('filter')($scope.selectedItem.lots, {'phase': $scope.selectedPhase.name}, true);
            $scope.lots = $filter('orderBy')(removed, ['number'], false);
        }

        $scope.lots.unshift({
            number: 'All'
        });
    };

    $scope.changeLot = function() {
        if (aceUtils.isUndefinedOrNull($scope.selectedItem)) return;
        $scope.showTasks = true;
    };

    $scope.submit = function() {
        $scope.submitted = true;
        angular.element('#calendar').fullCalendar('refetchEvents');
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/builders/public/controllers/builderCalendar.js